import React, { useState } from "react";
import Button from "@mui/joy/Button";
import Modal from "@mui/joy/Modal";
import ModalClose from "@mui/joy/ModalClose";
import Typography from "@mui/joy/Typography";
import Sheet from "@mui/joy/Sheet";
import LoadingGif from "../../../assets/loading.gif";
const DataLoader = () => {
  const [open, setOpen] = useState(true);

  return (
    <>
      <Modal
        aria-labelledby="close-modal-title"
        open={open}
        sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}
      >
        <Sheet
          variant="outlined"
          sx={{ minWidth: 300, borderRadius: "md", p: 3 }}
        >
          <div className="flex justify-center items-center">
            <div className="w-[200px] h-32 flex">
              <img
                src={LoadingGif}
                className="w-full h-full object-cover"
                alt=""
              />
            </div>
          </div>
        </Sheet>
      </Modal>
    </>
  );
};

export default DataLoader;
